import { render, staticRenderFns } from "./CodAdvanceTransfers.vue?vue&type=template&id=0d2ab39c&scoped=true"
import script from "./CodAdvanceTransfers.vue?vue&type=script&lang=js"
export * from "./CodAdvanceTransfers.vue?vue&type=script&lang=js"
import style0 from "./CodAdvanceTransfers.vue?vue&type=style&index=0&id=0d2ab39c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2ab39c",
  null
  
)

export default component.exports